// ─────────────────────────────────────────────────────────────
// Card
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

import { C } from "../../lib/colors";

export function Card({ children, style, glow, onClick }) {
  return (
    <div 
      style={{ 
        background: C.panel, 
        border: `1px solid ${glow ? glow + "40" : C.border}`, 
        borderRadius: 14, 
        padding: 20, 
        boxShadow: glow ? `0 0 20px ${glow}10` : "none", 
        cursor: onClick ? "pointer" : "default",
        ...style 
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

